// extracted by mini-css-extract-plugin
export default {"modal":"EgresosFiltra_modal__Vq2bp","nombre":"EgresosFiltra_nombre__m1wSv","botok":"EgresosFiltra_botok__TbPHX","contCheckboxes":"EgresosFiltra_contCheckboxes__AqsLB"};